import { render, staticRenderFns } from "./AppointmentHubTeams.vue?vue&type=template&id=d8fd72fa"
import script from "./AppointmentHubTeams.vue?vue&type=script&lang=ts"
export * from "./AppointmentHubTeams.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentHubTeams.vue?vue&type=style&index=0&id=d8fd72fa&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports